module.exports = __webpack_public_path__ + "static/media/organizer_9.5da50e6a.jpg";